import { filterNonDigits, filterNonDigitsDecimal } from "../../helpers";
import {
  ItemNumberSearchesState,
  ItemNumberSearchesActionType,
  ItemNumberSearchesActionTypes,
} from "./data.type";

const initialState: ItemNumberSearchesState = {
  newGlobalProduct: null,
  category: null,
  subCategory: null,
  productLine: null,

  itn_itemno: "",
  itn_itemnm: "",

  itn_cptype: null,
  itn_cplang: "",
  itn_cpgcod: "",
  itn_cpgnam: "",
  itn_inclfm: null,
  itn_lfmnum: "",
  itn_lfmnam: "",
  itn_plgtyp: null,
  itn_plgnam: "",
  itn_restri: "",
  itn_lifsts: null,
  itn_ean13d: "",
  itn_mfpnum: "",
  itn_upc12d: "",
  itn_relsdt: "",
  itn_reqmkt: null,
  marketing_material_id: null,
};

function reducer(
  state: ItemNumberSearchesState,
  action: ItemNumberSearchesActionType,
): ItemNumberSearchesState {
  switch (action.type) {
    case ItemNumberSearchesActionTypes.SET_NEW_ITEM_NUMBER:
      return {
        ...state,
        itn_itemno: action.payload.itn_itemno ?? "",
        itn_itemnm: action.payload.itn_itemnm ?? "",
      };
    case ItemNumberSearchesActionTypes.SET_NEW_GLOBAL_PRODUCT:
      return {
        ...state,
        newGlobalProduct: action.payload.newGlobalProduct ?? null,
        category: action.payload.newGlobalProduct?.sub_category?.parent ?? null,
        subCategory: action.payload.newGlobalProduct?.sub_category ?? null,
        productLine: action.payload.newGlobalProduct?.product_line ?? null,
      };
    case ItemNumberSearchesActionTypes.SET_CONSUMER_PACKAGING_TYPE:
      return {
        ...state,
        itn_cptype: action.payload.itn_cptype ?? null,
      };
    case ItemNumberSearchesActionTypes.SET_CONSUMER_PACKAGING_LANGUAGE:
      return {
        ...state,
        itn_cplang: action.payload.itn_cplang ?? "",
      };
    case ItemNumberSearchesActionTypes.SET_CONSUMER_PACKAGING_GLOBAL_CODE:
      return {
        ...state,
        itn_cpgcod: action.payload.itn_cpgcod ?? "",
      };
    case ItemNumberSearchesActionTypes.SET_CONSUMER_PACKAGING_GLOBAL_NAME:
      return {
        ...state,
        itn_cpgnam: action.payload.itn_cpgnam ?? "",
      };
    case ItemNumberSearchesActionTypes.SET_CATEGORY:
      return {
        ...state,
        category: action.payload.category ?? null,
        subCategory: null,
        newGlobalProduct: null,
      };
    case ItemNumberSearchesActionTypes.SET_SUB_CATEGORY:
      return {
        ...state,
        subCategory: action.payload.subCategory ?? null,
        category: action.payload.subCategory?.parent ?? null,
        newGlobalProduct: null,
      };
    case ItemNumberSearchesActionTypes.SET_PRODUCT_LINE:
      return {
        ...state,
        productLine: action.payload.productLine ?? null,
        newGlobalProduct: null,
      };
    case ItemNumberSearchesActionTypes.SET_INCLUDES_LEAFLET_MANUAL:
      return {
        ...state,
        itn_inclfm: action.payload.itn_inclfm ?? null,
      };
    case ItemNumberSearchesActionTypes.SET_INCLUDES_LEAFLET_NUMBER:
      return { ...state, itn_lfmnum: action.payload.itn_lfmnum ?? "" };
    case ItemNumberSearchesActionTypes.SET_INCLUDES_LEAFLET_NAME:
      return {
        ...state,
        itn_lfmnam: action.payload.itn_lfmnam ?? "",
      };
    case ItemNumberSearchesActionTypes.SET_MARKETING_MATERIAL:
      return {
        ...state,
        marketing_material_id: action.payload.marketing_material_id ?? null,
      };
    case ItemNumberSearchesActionTypes.SET_PLUG_TYPE:
      return { ...state, itn_plgtyp: action.payload.itn_plgtyp ?? null };
    case ItemNumberSearchesActionTypes.SET_PLUG_NAME:
      return { ...state, itn_plgnam: action.payload.itn_plgnam ?? "" };
    case ItemNumberSearchesActionTypes.SET_UPC12:
      return { ...state, itn_upc12d: action.payload.itn_upc12d ?? "" };    
    case ItemNumberSearchesActionTypes.SET_EAN13D:
      return { ...state, itn_ean13d: action.payload.itn_ean13d ?? "" };
    case ItemNumberSearchesActionTypes.SET_REGULATORY_RESTRICTIONS:
      return { ...state, itn_restri: action.payload.itn_restri ?? "" };
    case ItemNumberSearchesActionTypes.SET_RELEASE_DATE:
      return { ...state, itn_relsdt: action.payload.itn_relsdt ?? "" };
    case ItemNumberSearchesActionTypes.SET_LINE_PLANNING_STATUS:
      return {
        ...state,
        itn_lifsts: action.payload.itn_lifsts ?? null,
      };
    case ItemNumberSearchesActionTypes.SET_FILTERS_FROM_STORAGE:
      return { ...state, ...action.payload };
    case ItemNumberSearchesActionTypes.RESET:
      return initialState;
    default:
      throw Error("Unknown action: " + action.type);
  }
}

export const isStateEqualToInitialState = (
  state: ItemNumberSearchesState,
): boolean => {
  return Object.keys(initialState).every(
    (key) =>
      initialState[key as keyof ItemNumberSearchesState] ===
      state[key as keyof ItemNumberSearchesState],
  );
};

export const ItemNumberSearchesReducer = { initialState, reducer };
